import {gsap} from "gsap";
import {Background} from "./Background";
import {GameFeatureMode} from "../enums/Enum";
import {Game} from "../Game";

export class BgCarousel extends PIXI.Container {
    private _spriteHeight: number = 1680;
    private _levels: string[] = ["reception", "mainGame", "freeSpin", "coolFreeSpin", "superFreeSpin"];
    private _mainBg: Background;
    private _bgList: Background[] = [];
    private _currentLevel: number = 0;

    constructor() {
        super();
        this.name = "BG_CAROUSEL";
        this.init();
    }

    public getLevelByMode(mode: GameFeatureMode): number {
        let nextLevel: number = 0;
        switch (mode) {
            case GameFeatureMode.RESPIN:
            case GameFeatureMode.NORMAL:
                nextLevel = this._levels.indexOf("mainGame");
                break;
            case GameFeatureMode.FREESPIN:
                nextLevel = this._levels.indexOf("freeSpin");
                break;
            case GameFeatureMode.FREESPIN_COOL:
                nextLevel = this._levels.indexOf("coolFreeSpin");
                break;
            case GameFeatureMode.FREESPIN_SUPER:
                nextLevel = this._levels.indexOf("superFreeSpin");
                break;
        }
        return nextLevel;
    }

    public moveTo(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this.position, {
            duration: 2 + (Math.abs(level - this._currentLevel) - 1) * 0.5,
            y: -(level * this._spriteHeight * 0.7621)
        });
        tl.add(() => {
            this._currentLevel = level;
            this.addChild(this._bgList[level]);
        });
        return tl;
    }
    public onLiftCome(currentLevel: number, toLevel: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const minLevel: number = Math.min(currentLevel, toLevel);
        const maxLevel: number = Math.max(currentLevel, toLevel);
        tl.add(() => {
            for (let level: number = minLevel; level <= maxLevel; level++) {
                this._bgList[level].visible = true;
            }
        });
        tl.add(this._bgList[this._currentLevel].scaleTo(0.7621, 0.3333), 0);
        return tl;
    }

    public onLiftOut(toLevel: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            for (let level: number = 0; level < this._levels.length; level++) {
                if (level != toLevel) {
                    this._bgList[level].visible = false;
                }
            }
        });
        tl.add(this._bgList[toLevel].scaleTo(1, 1.6), 0);
        return tl;
    }

    public onIntroStart(): void {
        this._bgList[this._levels.indexOf("reception")].playAnim("intro_with_nurse", true);
    }

    public onIntroDone(): void {
        this._bgList[this._levels.indexOf("reception")].stopAnim();
        this._bgList[this._levels.indexOf("reception")].playAnim("intro_without_nurse", false);
    }

    public setTo(level: number, duration: number = 1.6): void {
        this.position.y = -(level * this._spriteHeight * 0.7621);
        this._currentLevel = level;
        this._bgList[level].visible = true;
        this._bgList[level].scaleTo(1, duration);
        Game.lift.updateDisplay(level);
    }

    private init(): void {
        for (let i: number = 0; i < this._levels.length; i++) {
            const bg: Background = new Background(i, this._levels[i]);
            this.addChild(bg);
            this._bgList.push(bg);
            if (this._levels[i] === "mainGame") {
                this._mainBg = bg;
            }
        }
        //move to Reception
        this.setTo(this._levels.indexOf("reception"));
    }

    get mainBg(): Background {
        return this._mainBg;
    }

    get bgList(): Background[] {
        return this._bgList;
    }

    get currentLevel(): number {
        return this._currentLevel;
    }

}